// Mirrors the backend VoiceInputMode: how the client drives the microphone for voice input in the text chat.
export enum VoiceInputMode {
    PushToTalk = 'push_to_talk',
    Toggle = 'toggle'
}
